import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import {createForms} from 'react-redux-form';
import {Sesion} from './reductorSesion';

export const ReduxStore = () => {
    
    return createStore(
            combineReducers({
                
                sesion: Sesion,
                                
            }),
            applyMiddleware(thunk,logger)
        );

}